import React from "react";
// import JsonData from "../data/data.json";

export const Services = (props) => {


  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            We Provide different types of service which includes metal work related to Iron,Steel and Almuninume
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="service-desc">
                    <i className={d.icon}></i>
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>

      </div>
    </div>
  );
};
